import '@grapecity/wijmo.styles/wijmo.css';
import 'flatpickr/dist/flatpickr.css';
import CacheBuster from 'react-cache-buster';
import ReactDOM from 'react-dom/client';
import version from './../package.json';
import './app.css';
import { PageTransition } from './common/components/page-transition';
import { AppProvider } from './common/context/Provider';
import App from './common/layout/App';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <CacheBuster
        currentVersion={version}
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        loadingComponent={<PageTransition />} //If not pass, nothing appears at the time of new version check.
        metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
        <AppProvider>
            <App />
        </AppProvider>
    </CacheBuster>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
